import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {Main} from "../../pages/main";
import {Layout} from "../layout";
import {PrivacyPolicy} from "../../pages/privacy-policy";
import {AboutCompany} from "../../pages/about-company";
import {Article1} from "../../pages/article1";
import {Article2} from "../../pages/article2";
import {Article3} from "../../pages/article3";
import {Article4} from "../../pages/article4";
import {ArticlesList} from "../../pages/articles-list";
import {PartnersList} from "../../pages/partners-list";
import {PartnerCard} from "../../pages/partner-card";
import {Event} from "../../pages/event";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<Layout/>}>
        <Route path="/" element={<Main/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
        <Route path="/brands" element={<PartnersList/>}/>
        <Route path="/brands/:id" element={<PartnerCard/>}/>
        <Route path="/about-company" element={<AboutCompany/>}/>
        <Route path="/article1" element={<Article1/>}/>
        <Route path="/article2" element={<Article2/>}/>
        <Route path="/article3" element={<Article3/>}/>
        <Route path="/article4" element={<Article4/>}/>
        <Route path="/articles-list" element={<ArticlesList/>}/>
        <Route path="/event/:titleUrl" element={<Event/>}/>
        <Route path="*" element={<Navigate to="/"/>}/>
      </Route>
    </Routes>
  );
};
